export default {
  'applicant_info': '/applicant-info',
  'applicant_first_preferred_subject': '/preferred-subjects',
  'applicant_info_second_subjects': '/preferred-subjects-other',

  'application_overview': '/application-overview',
  'subject_test': '/application-overview',
  'subject_test_success': '/application-overview',
  'subject_test_failed': '/application-overview',
  'subject_test_start': '/subject-test-start',
  'language_test_failed': '/application-overview',

  'welcome_page': '/welcome',
  'language_test': '/language-test',
  'language_test_failed': '/application-overview',
  'finance_text_test': '/finance-test',
  'finance_text_test_start': '/finance-test-start',
  'phone_verification': '/phone-verification',

  'subject_essay_1': '/tasks',
  'sandbox_completed': '/phone-verification-2',

  'await_result': '/result',
  'hired': '/congratulations',
  'declined': '/sorry',
};



// WEBPACK FOOTER //
// ./src/constants/stages_v8.js